// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__EqaZW","modal__content":"Modal_modal__content__t8cOq","title":"Modal_title__p-V3F","subtitle":"Modal_subtitle__Sty0C","btn":"Modal_btn__fII-C"};